import {View} from 'MWC';
import React from 'react';
import tpl from '../templates/Tooltip.jsx';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            ui: this.uiStates.INITIAL,
            showModal: false,
            tooltipLeft: 0,
            tooltipTop: 0,
            arrowLeft: 0,
            tooltipMarginRight: 0,
            tooltipWinWidth: 0
        };

        this.tooltipRef = React.createRef();
        return this;
    }

    componentDidMount() {
        const {element} = this.props;
        const tooltip = this.tooltipRef.current;
        const halfTooltipWidth = tooltip.offsetWidth / 2;
        if (element) {
            let tooltipLeft = element.offsetLeft - halfTooltipWidth + element.offsetWidth / 2;
            let arrowLeft = halfTooltipWidth - 12;
            const tooltipTop = element.offsetTop + element.clientHeight + 17;
            if (halfTooltipWidth < element.offsetLeft) {
                this.setState({tooltipLeft, arrowLeft, tooltipTop});
            } else {
                tooltipLeft = 20;
                arrowLeft = element.offsetLeft - tooltipLeft + element.offsetWidth / 2 - 12;
                this.setState({tooltipLeft, arrowLeft, tooltipMarginRight: 20, tooltipTop});
            }
            if (!this.state.tooltipWinWidth) {
                this.setState({tooltipWinWidth: element.offsetWidth});
            }
        }
    }

    static defaultProps = {
        title: 'Put your title here',
        id: ''
    };
}
